import {reducer} from '../../../../../reducers/helpers'
import * as addItemsActions from './actions'
import {
  FETCH_PAYPAGE_REGISTRATION_ID_FAILURE,
  FETCH_PAYPAGE_REGISTRATION_ID_SUCCESS,
} from '../../../../../actions/worldpay'

const initialState = {
  isSubmittingBillingInformation: false,
  isAddItemsSuccess: false,
  isAddItemsError: false,
}
export default reducer(initialState, (state, {type}) => {
  switch (type) {
    case FETCH_PAYPAGE_REGISTRATION_ID_SUCCESS:
      return {
        isSubmittingBillingInformation: false,
        isAddItemsSuccess: true,
        isAddItemsError: false,
      }
    case FETCH_PAYPAGE_REGISTRATION_ID_FAILURE:
      return {
        isSubmittingBillingInformation: false,
        isAddItemsError: true,
        isAddItemsSuccess: false,
      }
    case addItemsActions.RESET_WORLDPAY_VALUES:
      return initialState
    default:
      return null
  }
})
